module.exports = __webpack_public_path__ + "static/media/account-minus-outline.68a745c3.svg";